import App from '@/App/index.vue';
import axios from 'axios';
import { vue } from '@/vue';
import Vue from 'vue';
import { i18n, i18nSetup } from "./i18n";
import "./polyfill";
import "./style";
import { router } from './vue/router';
import { queryParams } from './utils/query_params';
import { setupJupyter } from './jupyter';
import { appBasePath } from './utils/app_url';

if (appBasePath) {
    axios.defaults.baseURL = `${appBasePath}/`
}

window.addEventListener('load', start)

function start() {
    vue.setup()
    const $root = new Vue({
        router,
        i18n,
        render: (h) => h(App),
    }).$mount('#app')
    i18nSetup($root)
    queryParams.jupyter && setupJupyter()
    requestAnimationFrame(hideSpinner)

    // FIXME
    try {
        // @ts-ignore
        document.querySelectorAll('.jupyter-camera .coordBox')[0].style.display = 'none'
    } catch{ }
}

function hideSpinner() {
    const loading = document.querySelector('.loading')!
    loading.parentElement!.removeChild(loading)
}

